import { StepNavigation, Step } from '@/components/newRedesign/components'

interface StepIndicatorProps {
  currentStep: number
  totalSteps: number
}

const stepLabels = ['Detalles Generales', 'Documentación', 'Costos']

export function StepIndicator({ currentStep, totalSteps }: StepIndicatorProps) {
  // Convert currentStep to steps array
  const steps: Step[] = Array.from({ length: totalSteps }).map((_, index) => {
    const stepNumber = index + 1
    let status: 'completed' | 'current' | 'pending' = 'pending'

    if (stepNumber < currentStep) {
      status = 'completed'
    } else if (stepNumber === currentStep) {
      status = 'current'
    }

    return {
      id: stepNumber,
      label: stepLabels[index],
      status,
    }
  })

  return <StepNavigation steps={steps} />
}
